import { render } from "./ClinicalCoachingCard.vue?vue&type=template&id=fc8ff7a0&scoped=true&ts=true&lang=pug"
import script from "./ClinicalCoachingCard.vue?vue&type=script&lang=ts"
export * from "./ClinicalCoachingCard.vue?vue&type=script&lang=ts"

import "./ClinicalCoachingCard.vue?vue&type=style&index=0&id=fc8ff7a0&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./ClinicalCoachingCard.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/clinicalCoaching/clinicalCoachingCard.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2FclinicalCoaching%2FClinicalCoachingCard.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8ff7a0"]])

export default __exports__